/*
  This file is auto-generated. Do not edit it directly.
  To update this file, run `npm run codegen:common`.
*/

enum Role {
  DATA_WALL = "MP_DATA_WALL_GRANTED",
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_OP = "ROLE_OP",
  ROLE_BD = "ROLE_BD",
  ROLE_USER_MANAGER = "ROLE_USER_MANAGER",
  ROLE_CAPACITY_MANAGER = "ROLE_CAPACITY_MANAGER",
  ROLE_GENERAL_SETTINGS = "ROLE_GENERAL_SETTINGS",
  ROLE_PRICING = "ROLE_PRICING",
  ROLE_SCHEDULE_MANAGER = "ROLE_SCHEDULE_MANAGER",
  ROLE_REPORTING = "ROLE_REPORTING",
  ROLE_PARTNER = "ROLE_PARTNER",
  ROLE_STATION_MANAGER = "ROLE_STATION_MANAGER",
  ROLE_POWER_BI = "ROLE_POWER_BI",
  ROLE_DISPATCHER = "ROLE_DISPATCHER",
  ROLE_DRIVER = "ROLE_DRIVER",
}

export default Role;
